import { Hero } from '@/components/home/Hero';
import { Services } from '@/components/home/Services';
import { Stats } from '@/components/home/Stats';
import { ClientLogos } from '@/components/home/ClientLogos';
import { CTASection } from '@/components/home/CTASection';

const HomePage = () => {
  return (
    <main data-testid="home-page">
      <Hero />
      <Stats />
      <Services />
      <ClientLogos />
      <CTASection />
    </main>
  );
};

export default HomePage;
